import React, { useState } from 'react';
import MapComponent from './MapComponent';
import { db } from './firebase-config';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Home() {
  const navigate = useNavigate();
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [radius, setRadius] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const dataToSend = {
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
      radius: parseFloat(radius),
      email_address: email,
    };
    try {
      const docRef = await addDoc(collection(db, 'watchList'), dataToSend);
      console.log('Document written with ID: ', docRef.id);
      setMessage('Data submitted successfully!');
      setError('');

      const response = await axios.post('https://us-central1-chicago-crimes-420200.cloudfunctions.net/queryNearbyCrimesWithCORS', dataToSend);      const results = response.data;
      console.log(results);

      navigate('/results', { state: { docId: docRef.id, results: results } });

      setLatitude('');
      setLongitude('');
      setRadius('');
      setEmail('');
    } catch (error) {
      console.error('Error adding document: ', error);
      setMessage('');
      setError('Failed to submit data. Please try again.');
    }
  };


  return (
    <div className="home">
      <h1 className="text-3xl font-bold mb-6">Submit Your Query</h1>
      <MapComponent crimeData={[]} interactive={true} setLatitude={setLatitude} setLongitude={setLongitude} />
      <form onSubmit={handleSubmit} className="mt-4">
        <input
          type="number"
          value={latitude}
          onChange={(e) => setLatitude(e.target.value)}
          placeholder="Latitude"
          required
          className="input"
        />
        <input
          type="number"
          value={longitude}
          onChange={(e) => setLongitude(e.target.value)}
          placeholder="Longitude"
          required
          className="input"
        />
        <input
          type="number"
          value={radius}
          onChange={(e) => setRadius(e.target.value)}
          placeholder="Search Radius (in miles)"
          required
          className="input"
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your Email"
          required
          className="input"
        />
        <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          Submit
        </button>
      </form>
      {message && <p className="text-green-500 mt-4">{message}</p>}
      {error && <p className="text-red-500 mt-4">{error}</p>}
    </div>
  );
}

export default Home;